// extracted by mini-css-extract-plugin
export default {"mainLayout":"CoreLayout_mainLayout__dhjVW","boxed":"CoreLayout_boxed__8hzfe"};